var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"box",style:(_vm.fontColorSize),domProps:{"innerHTML":_vm._s(_vm.dom)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }